<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('machine_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-format-color-fill</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-material-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.material.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>

              <td><strong>{{ $t('profile.material.comment') }}</strong></td>
              <td>
                                    {{ item['comment'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.material.medium') }}</strong></td>
              <td>
                                    {{ item['medium'].name }}
              </td>

              <td><strong>{{ $t('profile.material.feedspec') }}</strong></td>
              <td>
                                    {{ item['feedSpec'].name }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.material.type') }}</strong></td>
              <td>
                                    {{ item['type'].name }}
              </td>

              <td><strong>{{ $t('profile.material.color') }}</strong></td>
              <td>
                                    {{ item['color'].name }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.material.manufacturer') }}</strong></td>
              <td>
                                    {{ item['manufacturer'].name }}
              </td>

              <td><strong>{{ $t('profile.material.state') }}</strong></td>
              <td>
                                    {{ item['state'].name }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('global.archive') }}</strong></td>
              <td>
                                    {{ item['archive']}}
              </td>

              <td><strong></strong></td>
              <td>
                                    
              </td>
            </tr>


          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'Material';

export default {
  name: 'MaterialShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('material', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('material', ['find'])
  },
  methods: {
    ...mapActions('material', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    })
  }
};
</script>
